var _rect, _rect2, _rect3, _path, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewyearHome24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_390)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 8,
    height: 9,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 1.92981,
    width: 4,
    height: 6,
    fill: "#E55050"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 0.92981,
    width: 6,
    height: 2,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_390",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5301 9.32068L13.4055 1.72017C12.9105 1.2571 12.6629 1.02556 12.3811 0.938112C12.1329 0.861124 11.8673 0.861124 11.6191 0.938112C11.3373 1.02556 11.0898 1.2571 10.5947 1.72017L2.47007 9.32068C1.32595 10.391 0.753894 10.9261 0.695364 11.386C0.639797 11.8226 0.811425 12.2574 1.15028 12.5382C1.50719 12.834 2.29054 12.834 3.85725 12.834V19.0055C3.85725 20.4456 3.85725 21.1657 4.13752 21.7157C4.38405 22.1996 4.77742 22.593 5.26127 22.8395C5.81133 23.1197 6.54092 23.1198 8.0001 23.1198C8.72966 23.1198 9.09446 23.1197 9.36952 22.9796C9.6114 22.8563 9.80812 22.6597 9.93137 22.4177C10.0715 22.1427 10.0715 21.7827 10.0715 21.0626V16.4769C10.0715 15.4118 10.935 14.5483 12.0001 14.5483C13.0653 14.5483 13.9287 15.4118 13.9287 16.4769V21.0626C13.9287 21.7827 13.9287 22.1427 14.0688 22.4177C14.1921 22.6597 14.3888 22.8563 14.6307 22.9796C14.9057 23.1197 15.2705 23.1198 16.0001 23.1198C17.4593 23.1198 18.1889 23.1197 18.7389 22.8395C19.2228 22.593 19.6161 22.1996 19.8627 21.7157C20.1429 21.1657 20.1429 20.4456 20.1429 19.0055V12.834C21.7096 12.834 22.493 12.834 22.8499 12.5382C23.1888 12.2574 23.3604 11.8226 23.3049 11.386C23.2463 10.9261 22.6743 10.391 21.5301 9.32068Z",
    fill: "#BE725A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5301 9.32068L13.4055 1.72017C12.9105 1.2571 12.6629 1.02556 12.3811 0.938112C12.1329 0.861124 11.8673 0.861124 11.6191 0.938112C11.3373 1.02556 11.0898 1.2571 10.5947 1.72017L2.47007 9.32068C1.32595 10.391 0.753894 10.9261 0.695364 11.386C0.639797 11.8226 0.811425 12.2574 1.15028 12.5382C1.50719 12.834 2.29054 12.834 3.85725 12.834V19.0055C3.85725 20.4456 3.85725 21.1657 4.13752 21.7157C4.38405 22.1996 4.77742 22.593 5.26127 22.8395C5.81133 23.1197 6.54092 23.1198 8.0001 23.1198C8.72966 23.1198 9.09446 23.1197 9.36952 22.9796C9.6114 22.8563 9.80812 22.6597 9.93137 22.4177C10.0715 22.1427 10.0715 21.7827 10.0715 21.0626V16.4769C10.0715 15.4118 10.935 14.5483 12.0001 14.5483C13.0653 14.5483 13.9287 15.4118 13.9287 16.4769V21.0626C13.9287 21.7827 13.9287 22.1427 14.0688 22.4177C14.1921 22.6597 14.3888 22.8563 14.6307 22.9796C14.9057 23.1197 15.2705 23.1198 16.0001 23.1198C17.4593 23.1198 18.1889 23.1197 18.7389 22.8395C19.2228 22.593 19.6161 22.1996 19.8627 21.7157C20.1429 21.1657 20.1429 20.4456 20.1429 19.0055V12.834C21.7096 12.834 22.493 12.834 22.8499 12.5382C23.1888 12.2574 23.3604 11.8226 23.3049 11.386C23.2463 10.9261 22.6743 10.391 21.5301 9.32068Z",
    fill: "#E64545"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 3,
    transform: "matrix(0.731354 0.681998 0.681998 -0.731354 9.08618 1.7948)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8482,
    y: 1.7948,
    width: 18,
    height: 3,
    transform: "rotate(137 14.8482 1.7948)",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 20,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 1,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 1,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 14,
    r: 1,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 14,
    r: 1,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12,
    r: 1,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewyearHome24);
export default __webpack_public_path__ + "static/media/newyear-home_24.5b695117.svg";
export { ForwardRef as ReactComponent };